import { FusePageCarded } from "@fuse";
import _ from "@lodash";
import { AppBar, DialogContent, IconButton, Toolbar, Typography, withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import CustomCrmForm from "app/Core/Components/CustomCrmForm/CustomCrmForm";
import XAPPDialog from "app/Core/Components/Dialog/XAPPDialog";
import DocumentoAtendimento from "app/Core/Components/DocumentoAtendimento/DocumentoAtendimento";
import Memed from "app/Core/Components/Memed/Memed";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import ArquivoApp from "app/GED/Arquivo/ArquivoApp";
import GaleriaApp from "app/GED/Galeria/GaleriaApp";
import CompartilharDocumentos from "app/Workflow/MinhasTarefas/Components/CompartilharDocumentos/CompartilharDocumentos";
import clsx from "clsx";
import MobileDetect from "mobile-detect";
import React from "react";
import { MdClose } from "react-icons/md";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import EmpresaPessoaFormularioApp from "../EmpresaPessoaFormulario/EmpresaPessoaFormularioApp";
import EmpresaPessoaProntuarioNavbar from "./EmpresaPessoaProntuarioNavbar";
const md = new MobileDetect(window.navigator.userAgent);

const styles = (theme) => ({
   toolbarDialog: {
      background: "linear-gradient(to right, " + theme.palette.primary.dark + " 0%, " + theme.palette.primary.main + " 100%)",
      minHeight: "32px !important",
   },
   chipTela: {
      backgroundColor: theme.palette.primary.dark,
      color: "#fff !important",
   },
   topBg: {
      background: theme.palette.background.paper,
   },
});


class EmpresaPessoaProntuarioDialog extends XAPPComponent {

   state = {
      showNavbar: true,
      tabValue: 0
   };

   componentDidUpdate(prevProps) {
      if (!prevProps.open && this.props.open) {
         this.handleChangeTab({}, 0);
      }
   }

   handleChangeTab = (ev, value) => {
      this.setState({ tabValue: value });
   };

   canPrintHeader = (xappRouteParams, user) => {
      var AResponse = 0;
      if (!_.isUndefined(user.settings.sistemas[xappRouteParams.empresa].dados.configuracao)) {
         let AConfig = _.find(user.settings.sistemas[xappRouteParams.empresa].dados.configuracao, { "chave": "IMPRIMIR_CABECALHO_ATENDIMENTO" });
         if (!_.isUndefined(AConfig)) {
            AResponse = 1;
         }
      }
      return AResponse;
   };

   canPrintFooter = (xappRouteParams, user) => {
      var AResponse = 0;
      if (!_.isUndefined(user.settings.sistemas[xappRouteParams.empresa].dados.configuracao)) {
         let AConfig = _.find(user.settings.sistemas[xappRouteParams.empresa].dados.configuracao, { "chave": "IMPRIMIR_RODAPE_ATENDIMENTO" });
         if (!_.isUndefined(AConfig)) {
            AResponse = 1;
         }
      }
      return AResponse;
   };

   render() {
      const { classes, xappRouteParams, openProntuario, open, user, readOnly, settings } = this.props;
      const { tabValue, showNavbar } = this.state;
      const canPrintHeader = this.canPrintHeader(xappRouteParams, user);
      const canPrintFooter = this.canPrintFooter(xappRouteParams, user);
      const idprofissional = settings.empresapessoaformulario[xappRouteParams.empresa].idpessoaformulario ?? null;

      return (
         <React.Fragment>
            <XAPPDialog
               id="EmpresaPessoaProntuario"
               open={!_.isNull(open)}
               onClose={this.onClose}
               fullWidth
               fullScreen
               className="overflow-hidden"
            >
               <div />
               <AppBar position="static" elevation={1}>
                  <Toolbar className={clsx(classes.toolbarDialog, "flex w-full")}>
                     <Typography variant="subtitle1 text-white">
                        {"Prontuário"}
                     </Typography>
                     <div style={{ flex: 1 }} />
                     <IconButton
                        key="close"
                        aria-label="Close"
                        className="p-6"
                        onClick={() => openProntuario(null)}
                     >
                        <MdClose className="text-20 text-white" />
                     </IconButton>
                  </Toolbar>
               </AppBar>
               <DialogContent className={"p-0 overflow-hidden"}>
                  <FusePageCarded
                     classes={{
                        header: clsx("", "h-fit min-h-px"),
                        leftSidebar: "w-fit",
                        sidebarHeader: "h-128 min-h-128",
                        topBg: classes.topBg,
                        contentWrapper: "p-0 overflow-hidden"
                     }}
                     header={
                        <React.Fragment>
                           <div className="flex w-full flex-row items-center">
                              <XAPPButton
                                 type="Icon"
                                 className=""
                                 onClick={() => {
                                    if (_.isNull(md.mobile()) && _.isNull(md.tablet()) && window.innerWidth > 1281)
                                       this.setState(_.set({ ...this.state }, "showNavbar", !showNavbar));
                                    else this.pageLayout.toggleLeftSidebar();
                                 }}
                                 iconProps={"justify-end"}
                                 icon={"list"}
                                 key={"iconOpenNavbar"}
                              />
                              <div className="flex-1" />
                              {!_.isNull(open) &&
                                 <>
                                    <CompartilharDocumentos
                                       xappRouteParams={xappRouteParams}
                                       idpessoaformulario={open.idpessoaformulario}
                                       idprofissional={open?.idprofissional ?? idprofissional}
                                    />
                                    <Memed
                                       data={{ ...open.formulario, idpessoaformulario: open.idpessoaformulario }}
                                       idfuncionalidade={""}
                                       xappRouteParams={xappRouteParams}
                                       callbackSave={() => window.changeFormulario(100)}
                                       callbackRemove={() => { }}
                                    />
                                 </>
                              }
                           </div>
                        </React.Fragment>
                     }
                     content={
                        <React.Fragment>
                           {!_.isNull(open) &&
                              <div className="h-full overflow-hidden" style={{ display: tabValue !== 0 && "none" }}>
                                 <DocumentoAtendimento
                                    canPrintHeader={canPrintHeader}
                                    canPrintFooter={canPrintFooter}
                                    readOnly={readOnly}
                                    xappRouteParams={xappRouteParams}
                                    idfuncionalidade={""}
                                    idagendamentopessoaformulario={""}
                                    status={""}
                                    idpessoaformulario={open.idpessoaformulario}
                                 />
                              </div>
                           }
                           {!_.isNull(open) && tabValue === 4 &&
                              <ArquivoApp
                                 xappRouteParams={xappRouteParams}
                                 idfuncionalidade={open.idpessoaformulario}
                                 campofuncionalidade={"idpessoaformulario"}
                                 tipo={1}
                                 showRemover={true}
                              />
                           }
                           {!_.isNull(open) && tabValue === 5 &&
                              <GaleriaApp
                                 xappRouteParams={xappRouteParams}
                                 idfuncionalidade={open.idpessoaformulario}
                                 campofuncionalidade={"idpessoaformulario"}
                                 tipo={1}
                                 listar={true}
                                 showRemover={true}
                              />
                           }
                           {!_.isNull(open) && tabValue === 9 && (
                              <EmpresaPessoaFormularioApp
                                 xappRouteParams={xappRouteParams}
                                 idparent={open.idpessoaformulario}
                              />
                           )}
                           {!_.isNull(open) && tabValue === 1 && (
                              <CustomCrmForm
                                 xappRouteParams={xappRouteParams}
                                 data={{ ...open.formulario, idpessoaformulario: open.idpessoaformulario, tags: open.tags }}
                                 settings={settings}
                              />
                           )}
                        </React.Fragment>
                     }
                     leftSidebarContent={
                        showNavbar && (
                           <EmpresaPessoaProntuarioNavbar
                              tabValue={tabValue}
                              handleChangeTab={this.handleChangeTab}
                              xappRouteParams={xappRouteParams}
                              settings={settings}
                           />
                        )
                     }
                     onRef={(instance) => {
                        this.pageLayout = instance;
                     }}
                     sidebarInner
                     innerScroll
                  />
               </DialogContent>
            </XAPPDialog>
         </React.Fragment>
      );
   }
}

function mapStateToProps({ auth }) {
   return {
      user: auth.user.data,
      settings: auth.user.data.settings,
   };
}

export default withRouter(connect(mapStateToProps)(withStyles(styles, { withTheme: true })(EmpresaPessoaProntuarioDialog)));

